module.exports = __webpack_public_path__ + "static/media/abtesting.2b8308e7.pdf";